export default __webpack_public_path__ + "static/media/most1.58135daf.jpg";